import React, { useEffect, useState } from 'react';
import {
    Button,
    Card,
    Modal,
    Space,
    Table,
    Tag,
    message
} from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import {getKermesOrders,cancelKermesOrder} from '../utils/api';

export default function KermesVentas({
    apiBase = '/api/kermes',
    userId = null
}) {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);

    const loadOrders = async () => {
    setLoading(true);

    try {
        const data = await getKermesOrders();

        setOrders(data.orders || []);

    } catch (error) {
        message.error(error.message);
    } finally {
        setLoading(false);
    }
};

useEffect(() => {
    loadOrders();
}, []);

const cancelOrder = (order) => {
    Modal.confirm({
        title: `Cancelar venta #${order.id}`,
        content: 'La venta no será eliminada; quedará registrada como cancelada.',
        okText: 'Cancelar venta',
        okButtonProps: { danger: true },
        cancelText: 'Cerrar',

        onOk: async () => {
            try {
                await cancelKermesOrder(order.id, userId);

                message.success('Venta cancelada.');

                loadOrders();

            } catch (error) {
                message.error(error.message);
            }
        }
    });
};

    const columns = [
        {
            title: 'Folio',
            dataIndex: 'id',
            render: id => `#${id}`
        },
        {
            title: 'Fecha',
            dataIndex: 'created_at'
        },
        {
            title: 'Piezas',
            dataIndex: 'total_items'
        },
        {
            title: 'Total',
            dataIndex: 'total',
            render: value => `$${Number(value).toFixed(2)}`
        },
        {
            title: 'Pago',
            dataIndex: 'payment',
            render: value => `$${Number(value).toFixed(2)}`
        },
        {
            title: 'Cambio',
            dataIndex: 'change_amount',
            render: value => `$${Number(value).toFixed(2)}`
        },
        {
            title: 'Estado',
            dataIndex: 'status',
            render: status =>
                status === 'completed'
                    ? <Tag color="green">Completada</Tag>
                    : <Tag color="red">Cancelada</Tag>
        },
        {
            title: 'Acciones',
            render: (_, record) =>
                record.status === 'completed' ? (
                    <Button
                        danger
                        onClick={() => cancelOrder(record)}
                    >
                        Cancelar
                    </Button>
                ) : null
        }
    ];

    return (
        <Card
            title="Historial de ventas"
            extra={
                <Button
                    icon={<ReloadOutlined />}
                    onClick={loadOrders}
                    loading={loading}
                >
                    Actualizar
                </Button>
            }
        >
            <Table
                rowKey="id"
                loading={loading}
                dataSource={orders}
                columns={columns}
                scroll={{ x: 900 }}
            />
        </Card>
    );
}
